<template>
  <div>
    <v-row class="pa-1">
      <v-col class="d-flex pa-0">
        <!-- Search -->
        <strong class="mt-2 mr-2">{{ $t("PROBLEM_TYPE") }}</strong>
        <v-select
          dense
          :items="probleType"
          v-model="keyword"
          item-value="key"
          hide-details
          outlined
          class="text-field-search mr-5"
        />
        <!-- Chapter -->
        <template v-if="subKey !== 'chapter'">
          <strong class="mt-2 mr-2"> エピソード</strong>
          <v-select
            dense
            :items="listChapter"
            item-value="Id"
            item-text="name"
            v-model="chapterId"
            hide-details
            outlined
            class="max-width-2 mr-5"
          />
        </template>
        <template v-else>
          <strong class="mt-2 mr-2"> エピソード</strong>
          <span class="mr-5 mt-2" v-if="listChapter.length > 0">{{
            listChapter.find((i) => i.Id == chapterId).name
          }}</span>
        </template>

        <!-- Section -->
        <strong class="mt-2 mr-2">シーン</strong>
        <v-select
          dense
          :items="listSection"
          item-value="Id"
          item-text="name"
          v-model="sectionId"
          hide-details
          :disabled="!chapterId"
          outlined
          class="max-width-2 mr-5"
        />

        <v-btn
          color="primary"
          class="font-weight-black"
          :disabled="!chapterId || !sectionId"
          @click="search"
          >{{ $t("SEARCH") }}</v-btn
        >
        <v-spacer />
        <v-btn
          color="primary"
          class="ml-10"
          @click="dialogConfirm = true"
          :disabled="selected.length == 0 || loadingCreate"
          >登録</v-btn
        >
      </v-col>
    </v-row>

    <!-- List Question -->
    <v-row>
      <v-layout class="mx-1 mt-5" child-flex>
        <v-data-table
          :headers="headers"
          fixed-header
          v-model="selected"
          :items="listQuestion"
          :single-select="listQuestion.length < 0"
          :items-per-page="50"
          item-key="no"
          :loading="loadingListQuestion"
          loading-text="読み込み中。。。待ってください。"
          hide-default-footer
          class="elevation-1"
          :show-select="listQuestion.length > 0"
        >
          <template v-slot:item.type_value="{ item }">{{
            probleType.find((e) => e.key == item.type_value)
              ? probleType.find((e) => e.key == item.type_value).text
              : ""
          }}</template>
          <template v-slot:item.lead_sentence="{ item }">
            <span class="pre-wrap">{{ item.lead_sentence }}</span>
          </template>
          <template v-slot:item.name="{ item: { type_value, name }, item }">
           <!-- type_value == 'Choices' -->
            <template
              v-if="type_value == 'Choices' && typeof name[0] != 'string'"
            >
              <v-row
                class="mx-0"
                v-for="(rowName, idx) in name"
                :key="`preview-${idx}`"
                :justify="
                  name.length == 1 && (!rowName[0] || !rowName[2])
                    ? 'center'
                    : null
                "
              >
                <span
                  class="text--h4 pre-wrap"
                  v-if="rowName[0]"
                  v-html="`${replaceText(rowName[0])}`"
                />
                <span
                  class="text--h4 font-weight-bold pre-wrap"
                  v-if="rowName[1] || rowName[1] == ''"
                  v-html="`（&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;）`"
                />
                <span
                  class="text--h4 pre-wrap"
                  v-if="rowName[1]"
                  v-html="`${replaceText(rowName[1])}`"
                ></span>
              </v-row>
            </template>
            <!-- type_value == 'Sort' -->
            <template v-if="type_value == 'Sort' && typeof name[0] != 'string'">
              <v-row
                class="mx-0"
                v-for="(rowName, idx) in name"
                :key="`preview-${idx}`"
                :justify="
                  name.length == 1 && (!rowName[0] || !rowName[2])
                    ? 'center'
                    : null
                "
              >
                <span class="pre-wrap text--h4">
                  <v-row class="d-flex mt-1" no-gutters>
                    {{ replaceText(rowName[0]) }}
                    <template v-if="rowName[1] || rowName[1] == ''">
                      <strong>1</strong>

                      <strong class="mx-1">2</strong>

                      <strong>3</strong>

                      <strong class="mx-1">4</strong>
                    </template>

                    <template v-if="rowName[1] || rowName[1] == ''">
                      {{ replaceText(rowName[1]) }}
                    </template>
                  </v-row>
                </span>
              </v-row>
            </template>
            <span
              v-html="nameConvert(item)"
              v-else-if="
                typeof name[0] == 'string' &&
                (type_value == 'Choices' || type_value == 'Sort')
              "
            />
            <span
              v-html="nameConvert(item)"
              v-else-if="type_value != 'Choices' && type_value != 'Sort'"
            />
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- View item -->
            <span class="mx-5">
              <v-icon size="22" @click="handleViewPriview(item)"
                >fas fa-eye</v-icon
              >
            </span>
          </template>
          <template v-slot:no-data>データがありません。</template>
        </v-data-table>
      </v-layout>
    </v-row>
    <Dialog v-model="dialogPreview" :width="400">
      <template v-slot:content>
        <component
          :is="`Template${isValue}`"
          :no="itemPreview ? itemPreview.no - 1 : 0"
        />
      </template>
      <template v-slot:actions>
        <v-btn color="primary" @click="dialogPreview = false" small>OK</v-btn>
      </template>
    </Dialog>
    <Dialog v-model="dialogConfirm" :title="$t('COMFIRMATION')">
      <template v-slot:content>登録します。よろしいですか。</template>
      <template v-slot:actions>
        <v-btn
          :disabled="loadingCreate"
          color="primary"
          small
          :loading="loadingCreate"
          @click="handleCreate"
          >{{ $t("OK") }}</v-btn
        >
        <v-btn color @click="dialogConfirm = false" small>{{
          $t("CANCEL")
        }}</v-btn>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { FormBuilder } from "@/views/listGeneral/formbuilder.js";
import { GetQuestionByFilter, createListQuestion } from "@/api/Question.api";
export default {
  store: ["formGeneral"],
  components: FormBuilder.$options.components,
  data() {
    return {
      keyword: "",
      listQuestion: [],
      loadingListQuestion: false,
      loadingCreate: false,
      dialogPreview: false,
      dialogConfirm: false,
      defaultListQuestion: [],
      isValue: "Choices",
      itemPreview: null,
      probleType: [
        { text: "全て", type: "all", key: "" },
        { text: "語彙・文法：4択", type: "write", key: "Choices" },
        { text: "語彙・文法：並び替え", type: "write", key: "Sort" },
        { text: "語彙・文法：ダイヤル入力", type: "write", key: "Conjugation" },
        { text: "漢字読み", type: "write", key: "Kanji" },
        { text: "短文聴解", type: "listen", key: "ShortSentences" },
        { text: "長文聴解", type: "listen", key: "LongSentences" },
      ],
      pagination: {
        page: 1,
        pageCount: 0,
        maxResultCount: 5,
      },
      selected: [],
      headers: [
        {
          text: "No.",
          align: "start",
          value: "no",
        },
        { text: this.$i18n.t("PROBLEM_TYPE"), value: "type_value" },
        { text: this.$i18n.t("DIRECTIVE"), value: "lead_sentence" },
        { text: this.$i18n.t("QUESTION"), value: "name", width: "30%" },
        {
          text: this.$i18n.t("ACTION"),
          value: "actions",
          align: "center",
          width: "150px",
        },
      ],
      chapterId: "",
      sectionId: "",
      listChapter: [],
      listSection: [],
      subKey: "",
    };
  },
  async created() {
    this.setSubKey();
  },
  mounted() {
    const { _, listChapter } = this;
    let menu = this.$ls.get("Menu_List");
    _.forEach(menu, (season) => {
      _.forEach(season.chapters, (chapter) => {
        listChapter.push(chapter);
      });
    });
    if (this.$route.params.chapter) {
      this.chapterId = this.$route.params.chapter;
      this.sectionId = this.$route.params.chapter;
    }
    if (this.$route.name !== "List General OF Section") {
      this.probleType.push(
        { text: "読解：4択", type: "read", key: "Comprehension" },
        { text: "読解：複数選択", type: "read", key: "MultiRead" }
      );
    }
  },
  watch: {
    $route: async function () {
      this.setSubKey();
      await this.handleGetQuestionByFilter();
    },
    chapterId: function (id) {
      const { _, listChapter } = this;
      _.forEach(listChapter, ({ ...item }) => {
        if (item.Id == id) {
          this.listSection = item.sections;
          if (this.subKey !== "chapter") {
            this.listSection.push({
              Id: item.Id,
              name: (item.name += "まとめ"),
            });
          }
        }
      });
    },
  },
  computed: {
    validateCreateButton() {
      const { subKey, defaultListQuestion } = this;
      if (subKey == "season" && defaultListQuestion.length == 50) {
        return true;
      } else if (subKey == "chapter" && defaultListQuestion.length == 30) {
        return true;
      } else if (subKey == "section" && defaultListQuestion.length == 10) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async handleGetQuestionByFilter() {
      console.log("--------");

      const { chapterId, sectionId } = this;
      let params = {
        chapter_id: chapterId,
        section_id: sectionId,
      };
      this.loadingListQuestion = true;
      let response = await GetQuestionByFilter(params).catch(this.$toast.error);
      if (!response) return (this.loadingListQuestion = false);
      this.listQuestion = [...response.result.list];
      this.defaultListQuestion = [...response.result.list];
      this.pagination.pageCount = response.result.count;
      this.loadingListQuestion = false;
    },
    async handleCreate() {
      const { _, sectionId, selected, subKey } = this;
      this.loadingCreate = true;
      let data = [];
      _.forEach(selected, (item) => {
        data.push({
          section_id: sectionId,
          id: item.Id,
        });
      });
      let params = {
        type: subKey,
        season_id: this.$route.params.season ? this.$route.params.season : "",
        chapter_id: this.$route.params.chapter
          ? this.$route.params.chapter
          : "",
        data,
      };
      await createListQuestion(params)
        .then(() => {
          this.loadingCreate = false;
          this.dialogConfirm = false;
          console.log("-----");
          this.$router.go(-1);
        })
        .catch((error) => {
          const { subKey } = this;
          if (error.response.data.result.error == "CREATE_ERROR") {
            if (subKey == "season") {
              this.$toast.error("50問題以外を登録できません。");
            }
            if (subKey == "chapter") {
              this.$toast.error("30問題以外を登録できません。");
            }
          }
          this.loadingCreate = false;
          this.dialogConfirm = false;
        });
    },
    setSubKey() {
      if (this.$route.name == "Select Create General OF Season") {
        this.subKey = "season";
      } else if (this.$route.name == "Select Create General OF Chapter") {
        this.subKey = "chapter";
      } else if (this.$route.name == "Select Create General OF Section") {
        this.subKey = "section";
      }
    },
    async search() {
      await this.handleGetQuestionByFilter();
      const { keyword } = this;
      this.selected = [];
      let keywordSearch = keyword.toLowerCase();
      this.listQuestion = this.defaultListQuestion.filter((item) => {
        return item.type_value.toLowerCase().search(keywordSearch) > -1;
      });
      this.pagination.pageCount = this.listQuestion.length;
    },
    handleEditORViewDetailItem(item, key) {
      let rearecte = this.paramsRearecte(key);
      rearecte.params.id = item.Id;
      if (key !== "Create") {
        rearecte.query = { no: item.no, ...this.$route.query };
      } else {
        let query = { ...this.$route.query, ...rearecte };
        rearecte.query = query;
      }
      this.$router.push(rearecte);
    },
    replaceText(name) {
      return name
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
    nameConvert(item) {
      const { type_value } = item;
      if (type_value == "Choices") {
        return `${this.replaceText(
          item.name[0]
        )}（&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;） ${this.replaceText(
          item.name[1]
        )}`;
      }
      if (type_value == "Sort") {
        return `${this.replaceText(
          item.name[0]
        )} <strong>1</strong> <strong>2</strong> <strong>3</strong> <strong>4</strong> ${this.replaceText(
          item.name[1]
        )}`;
      }
      if (type_value == "Conjugation") {
        let unline = "";
        item.list_answer.answer[0].forEach(() => {
          unline += " __ ";
        });
        return `${this.replaceText(
          item.list_answer.sentence_answer[0]
        )} ${unline} ${this.replaceText(item.list_answer.sentence_answer[1])}`;
      }
      if (type_value == "Kanji") {
        return `${this.replaceText(item.name[0][0])} <u>${this.replaceText(
          item.name[0][1]
        )}</u> ${this.replaceText(item.name[0][2])}`;
      }
      if (item.name[0] && item.name[0][0]) {
        return this.replaceText(item.name[0][0]);
      } else if (item.name[0]) {
        return item.name[0][0];
      } else {
        return "";
      }
    },
    paramsRearecte(key) {
      var paramsRearecte = "";
      const { query } = this.$route;
      if (this.$route.name == "List General OF Season") {
        paramsRearecte = {
          name: `${key} General OF Season`,
          params: { season: this.$route.params.season },
          query:
            key == "Create"
              ? { no: this.pagination.pageCount, ...query }
              : query,
        };
      } else if (this.$route.name == "List General OF Chapter") {
        paramsRearecte = {
          name: `${key} General OF Chapter`,
          params: { chapter: this.$route.params.chapter },
          query:
            key == "Create"
              ? { no: this.pagination.pageCount, ...query }
              : query,
        };
      } else if (this.$route.name == "List General OF Section") {
        paramsRearecte = {
          name: `${key} General OF Section`,
          params: { section: this.$route.params.section },
          query:
            key == "Create"
              ? { no: this.pagination.pageCount, ...query }
              : query,
        };
      }
      return paramsRearecte;
    },
    handleViewPriview(item) {
      console.log("item: ", item);
      const {
        type_value,
        name,
        lead_sentence,
        verb,
        list_answer,
        answer_correct,
        script,
        image,
        image_url,
        audio,
        audio_url,
        sub_question: { question1, question2 },
      } = item;
      this.itemPreview = item;
      this.isValue = type_value;
      this.formGeneral.leadSentence = lead_sentence;
      // If type = Choices || Sort
      if (type_value == "Choices" || type_value == "Sort") {
        this.formGeneral.name1 = name[0];
        this.formGeneral.name2 = name[1];
        this.formGeneral.answers.forEach(
          (e, index) => (e.value = item[`answer${index + 1}`])
        );
        this.formGeneral.isAnsewr = answer_correct[0];
      }
      // If type = Conjugation
      if (type_value == "Conjugation") {
        this.formGeneral.name1 = list_answer.sentence_answer[0];
        this.formGeneral.name2 = list_answer.sentence_answer[1];
        this.formGeneral.verb = verb;
        this.formGeneral.answersConjugation = list_answer.answer[0];
        this.formGeneral.wrongAnswersConjugation = list_answer.answer[1];
        this.formGeneral.isAnsewr = answer_correct[0];
      }
      // If type = kanji
      if (type_value == "Kanji") {
        this.formGeneral.name1 = name[0];
        this.formGeneral.kanji = name[1];
        this.formGeneral.name2 = name[2];
        this.formGeneral.isAnsewr = answer_correct[0];
        this.formGeneral.answers.forEach(
          (e, index) => (e.value = item[`answer${index + 1}`])
        );
      }

      // If type = ShortSentences
      if (type_value == "ShortSentences") {
        this.formGeneral.isAnsewr = answer_correct[0];
        this.formGeneral.script = script;
        this.formGeneral.audio = audio_url
          ? { fileUrl: audio_url, file_name: audio }
          : null;
        this.formGeneral.answers.forEach(
          (e, index) => (e.value = item[`answer${index + 1}`])
        );
      }

      // If type = LongSentences
      if (type_value == "LongSentences") {
        this.formGeneral.audio = audio_url
          ? { fileUrl: audio_url, file_name: audio }
          : null;
        this.formGeneral.script = script;
        this.formGeneral.sub_question.question1 = question1;
        this.formGeneral.sub_question.question2 = question2;

        this.formGeneral.sub_question.question1.audio = question1.audio_url
          ? { fileUrl: question1.audio_url, file_name: question1.audio }
          : null;
        this.formGeneral.sub_question.question2.audio = question2.audio_url
          ? { fileUrl: question2.audio_url, file_name: question2.audio }
          : null;
      }

      // If type = Comprehension
      if (type_value == "Comprehension") {
        this.formGeneral.name1 = name[0];
        this.formGeneral.name2 = name[1];
        this.formGeneral.isAnsewr = answer_correct[0];
        this.formGeneral.image = image_url
          ? { fileUrl: image_url, file_name: image }
          : null;
        this.formGeneral.answers.forEach(
          (e, index) => (e.value = item[`answer${index + 1}`])
        );
      }
      // If type = MultiRead
      if (type_value == "MultiRead") {
        this.formGeneral.name1 = name[0];
        this.formGeneral.name2 = name[1];
        this.formGeneral.isAnsewr = answer_correct;
        this.formGeneral.image = image_url
          ? { fileUrl: image_url, file_name: image }
          : null;
        this.formGeneral.answers.forEach(
          (e, index) => (e.value = item[`answer${index + 1}`])
        );
      }
      this.dialogPreview = true;
    },
  },
  beforeDestroy() {
    this.formGeneral = {
      leadSentence: "",
      name1: "",
      name2: "",
      isAnsewr: 1,
      verb: "",
      kanji: "",
      audio: null,
      image: null,
      script: "",
      sub_question: {
        question1: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
        question2: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
      },
      answers: [
        {
          id: 1,
          name: "回答1",
          value: "",
        },
        {
          id: 2,
          name: "回答2",
          value: "",
        },
        {
          id: 3,
          name: "回答3",
          value: "",
        },
        {
          id: 4,
          name: "回答4",
          value: "",
        },
      ],
      answersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
      wrongAnswersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
// .text-field-search {
//   max-width: 16rem;
// }
</style>